import React from 'react';
import { Container, Box, Grid, Card, CardContent, Typography } from '@mui/material';
import {
    ChatBubbleOutline as ChatBubbleOutlineIcon,
    DescriptionOutlined as DescriptionOutlinedIcon,
    TrendingUpOutlined as TrendingUpOutlinedIcon
} from '@mui/icons-material';

const HowItWorksSection = ({ FadeInSection }) => {
    const steps = [
        {
            icon: ChatBubbleOutlineIcon,
            title: 'Rozmawiasz',
            description: 'Wtedy kiedy potrzebujesz, bez oceniania odpowiadasz na pytania aplikacji, które pomogą Ci zbudować rozwiązania dla Twoich trudności. '
        },
        {
            icon: DescriptionOutlinedIcon,
            title: 'Tworzysz plan',
            description: 'Aplikacja zbiera Twoje odpowiedzi i tworzy Indywidualny PAKIET MOCY - dokument z konkretnymi krokami, wspierającymi myślami i strategiami, które możesz wdrożyć od razu.'
        },
        {
            icon: TrendingUpOutlinedIcon,
            title: 'Działasz',
            description: 'Masz gotowy plan, by poradzić sobie z trudnościami i odzyskać poczucie kontroli.'
        }
    ];

    return (
        <Box sx={{ py: 8, bgcolor: 'linear-gradient(135deg, #f0fdfa 0%, #ecfdf5 100%)' }}>
            <Container maxWidth="lg">
                <FadeInSection>
                    <Typography
                        variant="h3"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: 'grey.800',
                            mb: 2
                        }}
                    >
                        Zbuduj swój plan na lepszą przyszłość już teraz

                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: 'center',
                            color: 'grey.600',
                            mb: 6,
                            mx: 'auto'
                        }}
                    >
                        Masz trudność, która nie daje Ci spokoju? Nie wiesz co zrobić by wprowadzić zmiany?
                        Z aplikacją Find solution zbudujesz jasny plan działania – PAKIET MOCY, który pomoże Ci odzyskać kontrolę i zwiększyć motywację do działania.
                        Nie trać czasu na szukanie odpowiedzi w ciemno.
                        <br /><br />
                        Find solution to Twoje wsparcie w odbudowie dobrostanu - dokładnie wtedy, gdy naprawdę go potrzebujesz - w pracy, w relacjach, w walce ze stresem i w budowaniu nowych nawyków. Zyskaj spokój, jasność i konkretne rozwiązania bez czekania, bez oceniania.

                    </Typography>
                </FadeInSection>
                <span id="how-it-works" style={{ position: 'relative', top: '-100px' }}></span>

                <FadeInSection>
                    <Typography

                        variant="h3"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: 'grey.800',
                            mb: 4,
                            mt: 6
                        }}
                    >
                        Jak to działa?
                    </Typography>
                </FadeInSection>

                <Grid container spacing={4}>
                    {steps.map((step, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <FadeInSection delay={index * 0.1}>
                                <Card sx={{
                                    height: '100%',
                                    p: 2,
                                    textAlign: 'center',
                                    '&:hover': {
                                        transform: 'translateY(-5px)',
                                        boxShadow: '0 12px 35px rgba(0,0,0,0.1)'
                                    },
                                    transition: 'all 0.3s ease'
                                }}>
                                    <CardContent sx={{ height: '268px' }}>
                                        <step.icon sx={{ fontSize: 50, color: 'primary.main', mb: 2 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: 'grey.800' }}>
                                            {step.title}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'grey.600', lineHeight: 1.6 }}>
                                            {step.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </FadeInSection>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box >
    );
};

export default HowItWorksSection;
